import React from "react";
import { Route, Switch } from "react-router-dom";
import About from "./containers/About";
import Investors from "./containers/Investors";
import InjectionMoulds from "./containers/InjectionMoulds";
import Plastics from "./containers/Plastics";

const Routes = () => {
    return (
        <Switch>
            <Route exact path="/" component={About} />
            <Route exact path="/za-nas" component={About} />
            <Route exact path="/informatsiya-za-investitori" component={Investors} />
            <Route exact path="/shpritsformi" component={InjectionMoulds} />
            <Route exact path="/plastmasovi-izdeliya" component={Plastics} />
        </Switch>
    );
};

export default Routes;
